export default "./images/survio-1DoTd-assets-star_rating.png";